import { PopupDialog } from 'common/PopupDialog'
import { PopupDialogContent } from 'common/PopupDialog/PopupDialogContent'
import { AddComment } from 'containers/PostDetail/AddComment'
import { PostComments } from 'containers/PostDetail/PostComments'
import { Post } from 'models/Post'
import { Flex } from 'primitives/Flex'
import { RefObject } from 'react'

interface Props {
  post: Post
  commentRef?: RefObject<HTMLDivElement>
  isOpen: boolean
  onClose: () => void
  onAddComment: () => void
}
export const CommentsDrawer: React.FC<Props> = ({
  post,
  commentRef,
  isOpen,
  onClose,
  onAddComment,
}) => {
  return (
    <PopupDialog isOpen={isOpen} onIgnore={onClose}>
      <PopupDialogContent css={{ overflow: 'scroll', height: '70vh' }}>
        <Flex column css={{ overflow: 'auto' }}>
          <PostComments
            post={post}
            css={{ marginBottom: '70px', overflowY: 'scroll' }}
            ref={commentRef}
          />
          <AddComment
            post={post}
            onAddComment={onAddComment}
            css={{
              position: 'absolute',
              bottom: 0,
              left: 0,
              div: {
                margin: 0,
                borderBottomLeftRadius: '0',
                borderBottomRightRadius: '0',
              },
            }}
          />
        </Flex>
      </PopupDialogContent>
    </PopupDialog>
  )
}
